import { Inject, Injectable, Injector, PLATFORM_ID, signal } from '@angular/core';
import { ToastrService } from '../toast/toastr.service';
import { ActivatedRoute, Router } from '@angular/router';
import { isPlatformBrowser, Location } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Constant} from '../../../utils/contants';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  ip = signal<string | null>(null);

  constructor(
    private location: Location,
    private toastr:ToastrService,
    private router: Router,
    private http: HttpClient,
    private injector: Injector,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  getBrowserIP(){
    if (environment.baseURL.includes('localhost')) return;

    this.http.get<{ ip?: string }>('https://api.ipify.org?format=json').subscribe({
      next: (res) => { if (!!res?.ip) { this.ip.set(res.ip) }},
      error: (e) => console.error(e)
    })
  }


  async copyToClipboard(content:any, responseMessage?:string){
    try {
      if (!navigator.clipboard) throw '';
      await navigator.clipboard.writeText(content)
      this.toastr.showInfo(responseMessage || 'Copied to clipboard!');
    } catch (error) {
      // Fallback to execCommand if Clipboard API is not supported
      const textarea = document.createElement('textarea');
      textarea.value = content;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      this.toastr.showInfo(responseMessage || 'Copied to clipboard!');
      document.body.removeChild(textarea);
    }

  }

  goBack(){
    const referrer = document.referrer;
    const currentHost = window.location.host;

    if ((window.history.length > 2)) {
      this.location.back();
    } else {
      this.router.navigate(['/']); // Navigate to home
    }
  }

  goBackOneLevel(count = 1){
    const route = this.injector.get(ActivatedRoute);
    const arr = (new Array(count)).map((_) => '../');
    this.router.navigate([arr.join('')], { relativeTo: route });
  }

  get isBrowser () {
    return isPlatformBrowser(this.platformId)
  }

  get isMobile () {
    return this.isBrowser && Constant.isMobile();
  }

  get isTablet () {
    return this.isBrowser && Constant.isTablet();
  }

  private getFormValidationErrorMessage(message:any, key:string){
    if (typeof message === 'string') {
      return message
    }

    if (key === 'required') return 'Required!';
    if (key === 'email') return 'Enter a valid email';

    return 'Invalid input';
  }

  isFormValueInvalid(form:FormGroup, formControlName:string, errorToCheck?: string, returnMessage?:boolean) {
    if (form.get(formControlName)?.touched && form.get(formControlName)?.invalid) {
      const errors = form.get(formControlName)?.errors || {error: true};

      if (errorToCheck) {
        if (returnMessage) {
          return this.getFormValidationErrorMessage(errors[errorToCheck], errorToCheck);
        }

        return !!errors[errorToCheck]
      }

      if (returnMessage && !!errors) {
        const key = (Object.keys(errors))[0];
        return this.getFormValidationErrorMessage(errors[key], key);
      }

      return true;
    }

    return false;
  }
}
